import axios from './axios';
import { serviceUrls } from './serviceUrls';

export const fetchDefaultQuestions = (
  data,
  config = null,
  axiosInstance = axios
) => {
  return axiosInstance.post(serviceUrls().defaultQuestions, data, config);
};

export const fetchJobQuestions = (
  data,
  config = null,
  axiosInstance = axios
) => {
  return axiosInstance.post(serviceUrls().jobQuestions, data, config);
};

export const submitScreeningQuestions = (
  data,
  config = null,
  axiosInstance = axios
) => {
  return axiosInstance.post(serviceUrls().submitScreeningQuestions, data, config);
};
